import { reducer as coverage } from "./coverage/slice";

export const reducer = {
  coverage,
};
